(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, function() {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/client/ClientInterface.js":
/*!***************************************!*\
  !*** ./src/client/ClientInterface.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ClientInterface": () => (/* binding */ ClientInterface)
/* harmony export */ });
//------------------------------------------------------------------
// Description: DSC Client Interface object. This is the client interface to DSC Server. There are 2 levels of DSC protocol:
//              messaging and communication. This interface abstracts the communication protocol. The messaging itself is
//              handled by the application. In the case of VIL, the Conference Manager and the uScope viewer handle messaging.
//              This interface object depends on the internal communication module called g_dscConnection. All logic is contained
//              in that object.
// Author:      Kiran Saligrama
// Interface Description:
//              setDSCURI:  DSC client connects to DSC Server via Apache. This uses Apache's reverse proxy capabilities.
//                          This property contains the string used in Apache config to redirect traffic to DSC Server.
//              resetDSCConnection: Resets the internal communication object and the connection itself.
//              addDSCMessageHandler: Client of this module can use this method to add a callback routine. A message type can
//                                    be specified to restrict messages that this callback should be called on. Refer to _dscMessageTypes
//                                    for supported message types.
//                                    The set callback is called whenever a message is received from DSC Server. These could be
//                                    responses to messages sent by the client or event updates sent by the server.
//              addDSCErrorHandler: Clients can add handler functions for errors that occur at communication level.
//              sendDSCMessage: This method is called by the client to send any message to DSC Server. This accepts the message title
//                              an XML node called Data which contains message specific data and a type. The type is used to determine
//                              whether all messages should be sent or only the latest should be sent. Refer to MessageTypes file for
//                              specific mapping.
//
// Include Order: This component depends on DSCClientUtil, DSCMessageQueue and DSCMessageTypes modules. A specific include order is
//                required.
//                  consts.js
//                  DSCMessageQueue.js
//                  DSCClientUtil.js
//                  DSCClientIntf-v1.js
//
//------------------------------------------------------------------
class ClientInterface {
  constructor(connection) {
    this._dscConnection = connection;
  }

  setDSCURI(value) {
    this._dscConnection.setDSCURI(value);
  }

  resetDSCConnection() {
    this._dscConnection.reset();
  }

  addDSCMessageHandler(msgType, handlerFunction) {
    this._dscConnection.addDSCMessageHandler(msgType, handlerFunction);
  }

  addDSCErrorHandler(handlerFunction) {
    this._dscConnection.addDSCErrorHandler(handlerFunction);
  }

  sendDSCMessage(msgTitle, msgDataNode, msgType) {
    this._dscConnection.sendDSCMessage(msgTitle, msgDataNode, msgType, undefined, undefined);
  }

}

/***/ }),

/***/ "./src/client/ClientVil.js":
/*!*********************************!*\
  !*** ./src/client/ClientVil.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createDscClientVil": () => (/* binding */ createDscClientVil)
/* harmony export */ });
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./logger */ "./src/client/logger.js");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./consts */ "./src/client/consts.js");
/* harmony import */ var _xml_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./xml-utils */ "./src/client/xml-utils.js");



function createDscClientVil($, events, translate, conference, g_dscClient) {
  var _participant = {
    ptName: '',
    ptUserId: 0,
    confName: 'Dummy',
    confId: 0,
    confPwd: '',
    confToken: '',
    createConf: false,
    confManagerDivId: '',
    isLeader: false,
    vilDivId: '',
    conferenceType: _consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.CASE,
    //Case, Study
    conferenceTopLevelPrimaryKey: '' //Primary Key for the conference table

  }; // public

  function resetParticipant(resetAll) {
    if (resetAll) {
      _participant.ptName = '';
      _participant.ptUserId = 0;
      _participant.confName = 'Dummy';
      _participant.confId = 0;
      _participant.confPwd = '';
      _participant.confToken = '';
      _participant.createConf = false;
      _participant.confManagerDivId = '';
      _participant.isLeader = false;
      _participant.vilDivId = '';
      _participant.conferenceType = _consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.CASE;
      _participant.conferenceTopLevelPrimaryKey = '';
    }

    g_dscClient.resetDSCConnection();
  }

  function dscMessageRouter(respType, dscRoot) {
    switch (respType) {
      case 'New Participant Response':
        if (_participant.createConf) createConference();else joinConference();
        break;

      case 'New Conference Response':
        updateParticipantList(null);
        break;

      case 'Join Conference Response':
        followConference();
        updateParticipantList(null);
        break;

      case 'Leave Conference Response':
      case 'Close Conference Response':
        cleanup();
        break;

      case 'Conference Closed':
        confClosed();
        cleanup();
        break;

      case 'New Leader':
        //if this user is the new leader
        if (dscRoot.getElementsByTagName('Participant')[0].attributes.getNamedItem('Name').value === _participant.ptName) {
          leadConference();
        } else {
          followConference();
        }

      // fallthrough intentional?

      case 'Add Participant':
        updateParticipantList(null);
        break;

      case 'Remove Participant':
        var name = dscRoot.getElementsByTagName('Participant')[0].attributes.getNamedItem('Name').value;

        if (name !== _participant.ptName) {
          dscAddLineToChat(name, translate('client-vil.manager.left-conference'));
        }

        updateParticipantList(null);
        break;

      case 'List Participants Response':
        updateParticipantList(dscRoot);
        break;

      case 'Assign Leadership Response':
        followConference();
        break;

      case 'Participant Data Changed':
        updateParticipantList(dscRoot);
        break;

      case 'Update Data':
        updateUserMsgList(dscRoot);
        break;
    }
  }

  function dscErrorHandlerFunc(errType, respType, dscRoot) {
    if (errType === _consts__WEBPACK_IMPORTED_MODULE_1__._dscErrorTypes.confNetError) {
      if (_participant.ptName !== '') //abort errors happen when resetDSCConnection is called as part of reset. This forces us to ignore such spurious errors
        {
          var msg = translate('client-vil.error.lost-connection');
          alert(msg);
          confClosed();
          cleanup();
          (0,_logger__WEBPACK_IMPORTED_MODULE_0__.dscConsoleLog)('Network error detected: Exiting conference');
        }
    } else {
      var errorDescription = getXMLNodeText(dscRoot, 'Description');
      (0,_logger__WEBPACK_IMPORTED_MODULE_0__.dscConsoleLog)('Error: ' + respType + ' Failed. Reason: ' + errorDescription);
      events.trigger('lbs-dsc-error', respType, errorDescription);
    }
  }

  function cleanup() {
    resetParticipant(true);
    resetParticipantList();
    resetConfControl();
  }
  /************
   Conference management routines
   ************/


  function initParticipant(dscSettings) {
    _participant.ptName = dscSettings.fullName;
    _participant.ptUserId = dscSettings.userId;
    _participant.confName = dscSettings.dscName;
    _participant.confId = dscSettings.dscId;
    _participant.confToken = dscSettings.authToken;
    _participant.confManagerDivId = dscSettings.confManagerDivId;
    _participant.vilDivId = dscSettings.vilDivId;
    _participant.conferenceType = dscSettings.conferenceType;
    _participant.conferenceTopLevelPrimaryKey = dscSettings.conferenceTopLevelPrimaryKey;
    g_dscClient.addDSCMessageHandler(_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage, dscMessageRouter); //viewer takes care of image-related (attribute) messages

    g_dscClient.addDSCErrorHandler(dscErrorHandlerFunc); //Create User data node

    const msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
    const nd = msgDoc.createElement('User'); //add User node

    nd.setAttribute('Name', _participant.ptName);
    nd.setAttribute('Token', _participant.confToken);
    nd.setAttribute('Id', _participant.ptUserId);
    g_dscClient.sendDSCMessage('New Participant', nd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
  } // public


  function createConference(dscSettings) {
    var resultPromise = {};

    if (_participant.ptName === '') {
      _participant.createConf = true;
      initParticipant(dscSettings);
    } else {
      //Create User data node
      const msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      const dataNd = msgDoc.createElement('Data'); //create Data node

      let tempNd = msgDoc.createElement('Name'); //create Name node

      (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(tempNd, _participant.confId);
      dataNd.appendChild(tempNd);
      tempNd = msgDoc.createElement('Id'); //Add conf id node

      (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(tempNd, _participant.confId);
      dataNd.appendChild(tempNd);
      tempNd = msgDoc.createElement('Attribute_List'); //add atribute list

      dataNd.appendChild(tempNd);
      g_dscClient.sendDSCMessage('New Conference', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage); // set DSC availability to busy

      resultPromise = conference.setDscAvailability(_consts__WEBPACK_IMPORTED_MODULE_1__.UserDscAvailability.Busy);
    }

    $.when(resultPromise).done(function () {
      $('#confManager').data('initiator', true);
      $(document).trigger('VILJoinConference');
    });
  } // public


  function joinConference(dscSettings) {
    var resultPromise = {};

    if (_participant.ptName === '') {
      _participant.createConf = false;
      initParticipant(dscSettings);
    } else {
      //Create User data node
      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var dataNd = msgDoc.createElement('Data'); // create Data node

      var confNd = msgDoc.createElement('Conference'); // create Conference node

      confNd.setAttribute('Name', _participant.confId);
      confNd.setAttribute('Id', _participant.confId);
      dataNd.appendChild(confNd);
      g_dscClient.sendDSCMessage('Join Conference', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
      resultPromise = conference.setDscAvailability(_consts__WEBPACK_IMPORTED_MODULE_1__.UserDscAvailability.Busy); // set DSC availability to busy
    }

    $.when(resultPromise).done(function () {
      $('#confManager').data('initiator', false);
      $(document).trigger('VILJoinConference');
    });
  }
  /** public
   * Send message to leave conference, then return promise to set dsc availability
   * @returns {unresolved}
   */


  function leaveConference() {
    var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
    var dataNd = msgDoc.createElement('Data'); //Create data node
    // TODO: Because sendDSCMessage is async, we cannot be sure that the call has completed before we return from this function
    // and since a caller of this function may reload the page after leaving the conference, the message may not be sent
    // Correct solution is for function sendDSCMessage to return a promise (for example, see conference.setDscAvailability)
    // if initiator, close conference; else if participant, leave conference

    if (_participant.createConf) g_dscClient.sendDSCMessage('Close Conference', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);else g_dscClient.sendDSCMessage('Leave Conference', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage); // set DSC availability to available

    $(document).trigger('VILLeaveConference'); // listener sets avaialbility UI elements

    return conference.setDscAvailability(_consts__WEBPACK_IMPORTED_MODULE_1__.UserDscAvailability.Available);
  }

  function confClosed() {
    $('#confManager').dialog('close'); // this call should result in the above leaveConference() being called
  }
  /*
  Participant management functions
  */


  function updateParticipantList(msgRoot) {
    if (msgRoot == null) {
      // Create User data node
      const msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      const dataNd = msgDoc.createElement('Data'); //create Data node

      g_dscClient.sendDSCMessage('List Participants', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
    } else {
      resetParticipantList();
      var prt = '';
      var prtName = '';
      var isLdr = false;
      var reqLdr = false;
      var prtList = msgRoot.getElementsByTagName('Participant');

      for (var prtInd = 0; prtInd < prtList.length; prtInd++) {
        prt = prtList[prtInd];
        prtName = prt.attributes.getNamedItem('Name').value;
        const isMe = prtName === _participant.ptName;
        isLdr = prt.attributes.getNamedItem('Leader').value === 'TRUE' ? true : false;
        const isInitiator = prt.attributes.getNamedItem('Creator').value === 'TRUE' ? true : false;
        reqLdr = prt.attributes.getNamedItem('Queue_Index').value === '-1' ? false : true;
        addParticipant(prtName, isLdr, isInitiator, isMe, reqLdr);
      }
    }
  }

  function addParticipant(prtName, isLeader, isInitiator, isMe, reqLeadership) {
    var $t = translate.scope('client-vil.manager');
    var prtListNode = $('#prtListId');
    var nameText = prtName;

    if (isInitiator || isMe) {
      nameText += ' (';
      if (isInitiator) nameText += $t('name-host');
      if (isInitiator && isMe) nameText += ' ';
      if (isMe) nameText += $t('name-me-small');
      nameText += ')';
    }

    var img = document.createElement('img');
    var requestLeadershipFn;
    var title = '';
    var imgClass = ['dscImg'];
    var giveControl; // Assign the "get leadership" function

    if (isMe) {
      requestLeadershipFn = requestLeadership;
    }

    if (isInitiator) {
      requestLeadershipFn = grabLeadership;

      if (isMe) {
        var inviteButton = $('#confInviteBtn');
        inviteButton.css('visibility', 'visible');
      }
    } // Create html for participant


    if (isLeader) {
      img.src = '/images/leader.png';
    } else if (reqLeadership) {
      if (_participant.isLeader) {
        img.src = '/images/leader.png';
        giveControl = document.createElement('button');
        giveControl.className = 'confBtn ui-button ui-widget ui-state-default ui-corner-all';
        giveControl.innerHTML = $t('give-control');
        giveControl.addEventListener('click', e => {
          assignLeadership(prtName);
          e.preventDefault();
          return false;
        });
      } else {
        img.src = '/images/requested.png';
        img.addEventListener('click', requestLeadershipFn);
      }
    } else {
      if (_participant.isLeader) {
        if (isMe === false) {
          title = $t('click-assign-control');
          imgClass.push('cursorPointer');
        }

        img.src = '/images/participant.png';
        img.title = title;
        img.addEventListener('click', () => {
          assignLeadership(prtName);
        });
      } else {
        if (isMe) {
          if (isInitiator) {
            title = $t('click-grab-control');
          } else {
            title = $t('click-request-control');
          }

          imgClass.push('cursorPointer');
        }

        img.src = '/images/participant.png';
        img.title = title;
        img.addEventListener('click', requestLeadershipFn);
      }
    }

    imgClass.forEach(className => img.classList.add(className));
    const li = document.createElement('li');
    li.appendChild(img);
    li.appendChild(document.createTextNode(nameText));

    if (giveControl) {
      li.appendChild(giveControl);
    }

    prtListNode.append(li);
  }

  function resetParticipantList() {
    var prtListNode = document.getElementById('prtListId');

    if (prtListNode) {
      prtListNode.innerHTML = '';
    }
  } // public


  function inviteParticipants() {
    if (_participant.vilDivId !== '' && $('#' + _participant.vilDivId).is($.getVilInstance())) {
      $.getVilInstance().openConferenceInvite(_participant.confId, _participant.confName);
    }
  }
  /*
  Leadership management functions
  */
  // public


  function requestLeadership() {
    var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
    var dataNd = msgDoc.createElement('Data'); //create Data node. No real data required here

    g_dscClient.sendDSCMessage('New Leadership Request', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
  }

  function assignLeadership(userName) {
    var newLdr = 'Initiator';

    if (_participant.isLeader) {
      newLdr = userName;
    }

    var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
    var dataNd = msgDoc.createElement('Data'); //create Data node

    var newLdrNd = msgDoc.createElement('Name'); //create user Name node

    (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(newLdrNd, newLdr);
    dataNd.appendChild(newLdrNd);
    g_dscClient.sendDSCMessage('Assign Leadership', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
    return false;
  } // public


  function grabLeadership() {
    var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
    var dataNd = msgDoc.createElement('Data'); //create Data node. No real data required here

    g_dscClient.sendDSCMessage('Grab Leadership', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
  }

  function sendUserMessage() {
    var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
    var dataNd = msgDoc.createElement('Data'); //create Data node

    var usrMsgNode = msgDoc.createElement('UserMessage');
    (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(usrMsgNode, $('#outgoingChatBox').val());
    dataNd.appendChild(usrMsgNode); //set to "" to send to all, set to a specific username to send to one user

    var destUsr = '';
    var destUsrNode = msgDoc.createElement('SendTo');
    (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(destUsrNode, destUsr);
    dataNd.appendChild(destUsrNode);
    g_dscClient.sendDSCMessage('Multicast Data', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
    dscAddLineToChat(translate('client-vil.manager.name-me'), $('#outgoingChatBox').val());
    $('#outgoingChatBox').val('');
  } // public


  function dscAddLineToChat(from, text) {
    var newLine = '\r\n';
    var chatBox = $('#confChatBox');
    chatBox.append(from + ': ' + text + newLine);
    chatBox.scrollTop(chatBox[0].scrollHeight - chatBox.height());
  }

  function updateUserMsgList(msgRoot) {
    if (msgRoot) {
      var txtMsg = getXMLNodeText(msgRoot, 'UserMessage');
      var fromUsr = getXMLNodeText(msgRoot, 'SentBy');
      dscAddLineToChat(fromUsr, $.trim(txtMsg));
    }
  }
  /*********************
   * UI management functions
   *********************/


  function leadConference() {
    _participant.isLeader = true;
    document.getElementById('confFollower').attributes.getNamedItem('style').value = 'visibility:hidden';
    document.getElementById('confGrabDiv').attributes.getNamedItem('style').value = 'visibility:hidden';
  }

  function followConference() {
    _participant.isLeader = false;
    document.getElementById('confFollower').attributes.getNamedItem('style').value = 'visibility:visible';
    if (_participant.createConf) document.getElementById('confGrabDiv').attributes.getNamedItem('style').value = 'visibility:visible';
  }

  function resetConfControl() {
    document.getElementById('confFollower').attributes.getNamedItem('style').value = 'visibility:hidden';
    document.getElementById('confGrabDiv').attributes.getNamedItem('style').value = 'visibility:hidden';
  }

  var getXMLNodeText = function (node, selector) {
    return $(node).find(selector).text();
  };

  return {
    _participant,
    resetParticipant,
    createConference,
    joinConference,
    inviteParticipants,
    requestLeadership,
    grabLeadership,
    dscAddLineToChat,
    leaveConference,
    sendUserMessage
  };
}

/***/ }),

/***/ "./src/client/Conference.js":
/*!**********************************!*\
  !*** ./src/client/Conference.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Conference": () => (/* binding */ Conference)
/* harmony export */ });
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./consts */ "./src/client/consts.js");
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utility */ "./src/client/utility.js");
/* harmony import */ var _ConferenceInvite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ConferenceInvite */ "./src/client/ConferenceInvite.js");
/* eslint-disable  no-prototype-builtins */



/*
 * Candles creating and managing slide conferences
 */

function Conference(sysParams, $, events, translate) {
  const self = this;
  let circularClientVil; // "circular" because clientVil requires an instance of this Conference class, which requires an instance of the vilClient...

  const conferenceInvite = new _ConferenceInvite__WEBPACK_IMPORTED_MODULE_2__.ConferenceInvite($, events, translate, self); // another circular dependency...
  // Expose the event channel for comms with the outside world

  self.events = events;
  self.errorCount = 0;
  /*
   * set to true when the conference invitation poll is active, or we are in the
   * process of joining a conference. Also set to true if either the Conference Setup dialog
   * or the Conference Manager dialog is being displayed.
   * This prevents the conference invitation dialog from being displayed.
   */

  self.busyFlag = false;
  /**
   * Interval in milliseconds to check for conference invitations
   */

  self.conferenceInvitationResponsePollingIntervalMS = 10000; // public URLs that may differ in eSM vs AIH (noew deprecated/discontinued so just hardcoded here)

  self.saveEntitiesURL = "/saveDscInvitation.php";
  self.getSetupDialogURL = "/AddDSC.php";
  self.saveDscURL = "/DSC_Save.php";
  self.setDscAvailabilityURL = "/DscAvail_Save.php";
  self.getDscAvailabilityURL = "/DscAvail_Get.php";
  self.getDscInviteURL = "/conference.blade.php";
  self.getDscInviteRequestURL = "/GetDsc.php";
  self.getDscInviteResponseURL = "/getDscInviteResponse.php";
  self.setDscInviteResponseURL = "/setDscInviteResponse.php";
  /**
   * Get the logged in user auth token
   * @returns string
   */

  self.authToken = function () {
    if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams)) {
      return sysParams.AuthToken;
    } else {
      return '@token';
    }
  };
  /**
   * Get the logged in user full name, or login name if no full name
   * @returns string
   */


  self.fullName = function () {
    if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams)) {
      return typeof (sysParams.FullName !== 'undefined') && sysParams.FullName !== '' ? sysParams.FullName : sysParams.LoginName;
    } else {
      return '';
    }
  };
  /**
   * Get the logged in user id
   * @returns string
   */


  self.userId = function () {
    if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams)) {
      return sysParams.UserId;
    } else {
      return '';
    }
  };
  /**
   * Get the logged in user id
   * @returns string
   */


  self.setUserId = function (id) {
    if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams)) {
      sysParams.UserId = id;
    }
  };
  /*
   * @returns bool
   * @param bool busyFlag - optional, specifies new busy state
   */


  self.isBusy = function (busyFlag) {
    if (undefined !== busyFlag) {
      self.busyFlag = busyFlag;
    } // return true if busyFlag is true if either the Conference Setup dialog or the Conference Manager dialog is being displayed


    return self.busyFlag === true;
  };
  /**
   * Get the DST active primary key value
   * @returns
   */


  self.dstCurrentRecordId = function () {
    return $.getDstInstance().getActiveViewModel().activeCase().recordId;
  };
  /**
   * Given a conference id and name, get the URL parameters needed to create a conference setup dialog for either a study or case
   * @param DscId Conference Id
   * @param DscName Conference Name
   */


  self.getSetupManagerParams = function (DscId, DscName) {
    //default conference to use
    var schema = 'dbo';
    var tableName = 'Case';
    var recordId = self.dstCurrentRecordId();
    return encodeURI('DscName=' + DscName) + encodeURI('&DscId=' + DscId) + encodeURI('&Schema=' + schema) + encodeURI('&TableName=' + tableName) + encodeURI('&RecordId=' + recordId);
  };
  /**
   * Check Join Conference role permission. If current role doesn't have that permission
   * @returns {Boolean}
   */


  self.canDoConferencing = function () {
    //check for ESM style SystemParms
    if (typeof sysParams !== 'undefined' && !$.isEmptyObject(sysParams)) {
      return !!sysParams.joinConferencing;
    } //default to false


    return false;
  };
  /*
   * Ping server to see if there is a conference invitation pending
   *
   * Returns false if token has expired
   */


  self.getConferenceInvitation = function (userId) {
    // if invite dialog is already open, nothing to do
    if (!self.isBusy()) {
      if (self.canDoConferencing()) {
        var params = undefined != userId ? {
          UserId: userId
        } : {}; // check for a conference invitation

        self.isBusy(true);
        $.getJSON(self.getDscInviteRequestURL, params).done(function (data) {
          if (!$.isEmptyObject(data)) {
            if (data.hasOwnProperty('LeaderName') && data.hasOwnProperty('Description') && data.hasOwnProperty('DscInvitationId') && data.hasOwnProperty('DscId')) {
              conferenceInvite.presentConfInviteDialog(data.DscId, data.Description, data.DscInvitationId, data.LeaderName);
              return;
            }

            if (data.hasOwnProperty('Alert')) {
              console.log('Error getting conference invitation: ' + data.Alert);
            }
          }

          self.isBusy(false);
        }).fail(function (jqxhr, textStatus, error) {
          self.isBusy(false); // don't report the first error, because an error can happen when changing pages.
          // but if it happens more than one time in a row, then it is an error that should
          // be reported
          //if (self.errorCount++ > 0)
          //{

          console.log('Error getting conference invitation: ' + textStatus + ' ' + error); //}
        });
      }
    }

    return true;
  };
  /*
   * decline a conference invitation. sets the DscInvitation Status to 3 (declining)
   */


  self.declineConference = function (dscInvitationId, declineReason) {
    // build json string to save the DscInvitation record
    var jsonStr = '{"Records":{"EntityBase":[{"Id" : "' + dscInvitationId + '","Status" : "' + _consts__WEBPACK_IMPORTED_MODULE_0__.INVITATION_STATUS.DECLINING + '","DeclineReason" :"' + declineReason + '","@attributes" : {"xsi:type" : "DscInvitation"}}]}}';
    postJSON(self.saveEntitiesURL, jsonStr).done(function () {}).fail(function () {
      (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.update-database'));
    }).always(function () {
      self.isBusy(false);
    });
  };
  /*
   * Join a conference invitation.
   * Sets the DscInvitation Status to 5 (accepting),
   * and creates the conference popup window
   * @param dscId - the id of the dsc record
   * @param dscInvitationId - the id of the DscInvitation record (not the id of the user)
   */


  self.joinConference = function (dscId, dscInvitationId, joinMessage = '') {
    // accept the conference invitation by setting the DscInvitation record's Status = DSCUSERSTATACCEPTED
    var jsonStr = '{"Records":{"EntityBase":[{"Id" : "' + dscInvitationId + '","Status" : "' + _consts__WEBPACK_IMPORTED_MODULE_0__.INVITATION_STATUS.ACCEPTING + '","DeclineReason" :"' + joinMessage + '","@attributes" : {"xsi:type" : "DscInvitation"}}]}}';
    postJSON(self.saveEntitiesURL, jsonStr).done(function () {
      if ($.fn.vil) {
        return self.finishJoinConference(dscId, dscInvitationId);
      } // When joining a conference we need access to the vil, which means viewer JS needs to be on the current page.
      // With WebViewer removed from eSM this isn't generally the case, so trying to join a conference would be futile.
      // This block shouldn't be hit in production; it's here to let developers (hi!) know webviewer needs to be on the page.


      console.error('Could not join a conference because viewer assets are expected and not present.');
      (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.join-coding-issue'));
    }).fail(function () {
      (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.update-database'));
    });
  };

  self.finishJoinConference = function (dscId, dscInvitationId) {
    // save current VIL/DST settings if any
    self.saveVilState(); // create the conference popup vil and join the conference

    self.createConferenceVIL(dscId, dscInvitationId);
  };
  /*
   * called when the user leaves a conference
   */


  self.leaveConference = function () {
    // clear the busy flag
    self.isBusy(false); // restore the saved VIL (if any)

    if ($(document).data('savedVilSettings') !== '') {
      $(document).removeData('savedVilSettings');
    }
  };
  /*
   * we are going to create a VIL instance for the conference,
   * but since there can only be one VIL in existence at a time, we need
   * to save the current VIL's (if any) settings and destroy that VIL.
   * That VIL will be recreated with the saved settings after the user
   * leaves the conference
   */


  self.saveVilState = function () {
    // find the vilContainer div (if any)
    var vilDiv = $(document).find('#vilContainer');

    if (vilDiv.length > 0) {
      // VIL is now a singleton, all VIL functions must be made on the
      // object returned by $.getVilInstance()
      //
      // need to make sure that the vilDiv we just found
      // is actually the one and only VIL instance
      var vilInstance = $.getVilInstance();

      if (vilDiv.is(vilInstance)) {
        // save the uScope state in the VIL settings and close the uScope
        vilInstance.uScopeSaveAndClose(); // save the VIL settings to be restored later

        $(document).data('savedVilSettings', vilInstance.getSettings()); // be careful - this used to clobber dstInfo with dstSettings -cb
        // save the DST state to the database
        ///??? Not needed for Peer Review, Needed in AIH ??
        // vilInstance.saveDst();
        // destroy the VIL ???
        // TODO: Do we need to save the DST state to the database here in 12.x?
      }
    }
  };

  self.getDSTInfoAsJson = function () {
    var result = '';
    var vilInstance = $.getVilInstance();

    if (undefined !== vilInstance) {
      vilInstance.syncSlideMemosFromDst(); // Make sure memos in VIL settings are synced up with any slide tray changes

      var vilSettings = vilInstance.getConfiguration(); // don't use getSettings here until it is fixed -cb

      result = JSON.stringify(vilSettings.dstInfo);
    }

    return result;
  }; // Note: This may be dead code -cb 8.5.2012


  self.saveDSTInfoToConference = function (dscId) {
    var vilInstance = $.getVilInstance();

    if (undefined !== vilInstance) {
      vilInstance.syncSlideMemosFromDst(); // Make sure memos in VIL settings are synced up with any slide tray changes

      var vilSettings = vilInstance.getConfiguration(); // don't use getSettings here until it is fixed -cb

      $.post('/DSC_DstInfoSave.php', 'DscId=' + dscId + '&DstInfo=' + encodeURIComponent(JSON.stringify(vilSettings.dstInfo))).fail(function (jqXHR, textStatus, errorThrown) {
        alert(translate('conference.error.slidetray-save', {
          status: textStatus,
          error: errorThrown
        }));
      });
    }
  }; // Note: This may be dead code -cb 8.5.2012


  self.getDSTInfoFromConference = function (dscId) {
    var vilInstance = $.getVilInstance();

    if (undefined !== vilInstance) {
      var vilSettings = vilInstance.getConfiguration(); // don't use getSettings here until it is fixed -cb

      $.getJson('/DSC_DstInfoGet.php', 'DscId=' + dscId).done(function (response) {
        $.extend(true, vilSettings.dstInfo, response);
      }).fail(function (jqXHR, textStatus, errorThrown) {
        alert(translate('conference.error.slidetray-retrieve', {
          status: textStatus,
          error: errorThrown
        }));
      });
    }
  };

  self.createConfManager = function (confName) {
    var $t = translate.scope('conference.manager');
    var managerDiv = $('<div>', {
      id: 'confManager'
    });
    $('body').append(managerDiv);
    const html = `
<div id="confControlDiv">
  <div class="dscHeader">
    <img class="dscHeaderImg" src="/images/participants.png" />
    ${$t('participants-header')}
    <input type="button" style="visibility: hidden;" value="${$t('invite-button')}" id="confInviteBtn" class="confBtn" title="${$t('tooltip-invite-additional')}" />
  </div>
  <br>
  <div id="prtListDiv">
    <ol id="prtListId" />
  </div>
  <input type="hidden" name="ptName" id="ptName" value="" style="visibility:hidden" />
  <input type="hidden" name="confName" id="confName" value="${confName}" style="visibility:hidden" />
  <div id="confFollower" style="visibility:hidden;">
    <input type="button" value="${$t('request-control')}" class="confBtn"/>
  </div>
  <div id="confGrabDiv" style="visibility:hidden;">
    <input type="button" value="${$t('grab-control')}" class="confBtn"/>
  </div>
  <br>
</div>
<br>
<b>${$t('chat-header')}</b>
<br>
<textarea rows="0" cols="0" readonly="readonly" id="confChatBox"></textarea>
<br>
<br>
<textarea rows="0" cols="0" id="outgoingChatBox" class="outgoingChatBox"></textarea>
`; // TODO: investigate next 2 lines. This looks stupid. #confManager was just created (line 363) and now we do a
    //       full document scan ...and then empty the already-empty div. Is this real? Why?

    var confManager = $('#confManager');
    confManager.empty();
    confManager.html(html);
    const outgoingChatBox = confManager.find('#outgoingChatBox');
    confManager.find('#confInviteBtn').on('click', circularClientVil.inviteParticipants);
    confManager.find('#confGrabDiv').on('click', circularClientVil.grabLeadership);
    confManager.find('#confFollower').on('click', circularClientVil.requestLeadership);
    confManager.find('#confChatBox').on('focus', () => outgoingChatBox.focus());
    confManager.dialog({
      autoOpen: false,
      title: $t('title'),
      modal: false,
      resizable: true,
      position: [15, 100],
      closeText: $t('close-tooltip'),
      open: function () {
        $('.confBtn').button();
        outgoingChatBox.attr('placeholder', $t('outgoing-chat-box-message'));
        outgoingChatBox.focus();
      },
      close: function () {
        // wait until after we close the conference (which includes an AJAX call to change status back to available) to reload original page
        $.when($().conference('close')).always(function () {
          events.trigger('lbs-dsc-conference-closed');
        });
      }
    });
    confManager.dialog('open');
    outgoingChatBox.on('keydown', event => {
      if (event.key === 'Enter') {
        circularClientVil.sendUserMessage();
        event.preventDefault();
        return false;
      }
    });
  };

  self.createConferenceVIL = function (dscId, dscInvitationId) {
    // start a conf manager with 'dsc name'
    self.createConfManager(dscId);
    $('#ptName').val(dscInvitationId); // join the conference

    var authToken = self.authToken();
    var fullName = self.fullName();
    var userId = self.userId();
    var DSCObject = {
      'dscId': dscId,
      'dscInvitationId': dscInvitationId,
      'authToken': authToken,
      'fullName': fullName,
      'userId': userId
    };
    $().conference('init');
    var json = {
      Records: {
        EntityBase: [{
          Id: dscInvitationId,
          Status: _consts__WEBPACK_IMPORTED_MODULE_0__.INVITATION_STATUS.ACCEPTING,
          '@attributes': {
            'xsi:type': 'DscInvitation'
          }
        }]
      }
    };
    postJSON(self.saveEntitiesURL, json).fail(function () {
      (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.update-database'));
    }); //join the conference with the dsc connection information

    $().conference('join', DSCObject);
  };

  self.enableConfSetupButton = function () {
    var enable = false;
    $('.dscUserCheckbox').each(function () {
      if ($(this).attr('checked') !== undefined) {
        enable = true;
        return false;
      }
    });
    var button = $('#confSetupDialog').closest('.ui-dialog').find('.ui-button').first(); // enable/disable first dialog button, and add/remove the jquery UI disabled class

    if (enable) {
      button.removeAttr('disabled').removeClass('ui-state-disabled');
    } else {
      button.attr('disabled', 'disabled').addClass('ui-state-disabled');
    }
  };
  /**
   * Show the conferencing setup dialog where the leader initially creates the conference
   * @param DscId
   * @param DscName
   */


  self.createConfSetupDialog = function (DscId, DscName) {
    if (undefined === DscId) {
      DscId = '';
    }

    if (undefined === DscName) {
      DscName = '';
    }

    var $t = translate.scope('conference.create'); // if DscId is empty, then we are creating a new conference, otherwise
    // we are inviting participants to an existing conference

    var createNewConference = '' === DscId;
    var ButtonText = createNewConference ? $t('create-button') : $t('invite-button');
    var dlgTitle = createNewConference ? $t('create-conference-title') : $t('invite-participants');
    $('<div>', {
      'id': 'confSetupDialog'
    }).appendTo('body');
    var confSetupParams = self.getSetupManagerParams(DscId, DscName); // TODO:  handle error condition if list of users is not received -cb

    $('#confSetupDialog').load(self.getSetupDialogURL, confSetupParams).dialog({
      autoOpen: true,
      title: dlgTitle,
      modal: true,
      resizable: false,
      height: 340,
      width: 320,
      close: function () {
        $(this).dialog('destroy').remove();
      },
      closeText: $t('close-tooltip'),
      buttons: [{
        text: ButtonText,
        id: 'btnCreateConference',
        click: function () {
          var participantCount = $('#DSCInviteForm').find('input:checked').length;

          if (participantCount < 1) {
            showMessageBox($t('select-one-participant'));
            return;
          }

          self.sendConferenceInvites().done(function (data) {
            if (createNewConference) {
              self.createNewConference(data.DscId, data.DscName);
            }
          });
          $(this).dialog('close');
        }
      }, {
        text: $t('cancel-button'),
        click: function () {
          $(this).dialog('close');
          $(this).empty();
        }
      }]
    });
  }; // Substitute for alert...


  function showMessageBox(text) {
    var $container = $('<div>' + text + '</div>');
    var $t = translate.scope('conference.create');
    $container.dialog({
      modal: true,
      closeText: $t('close-tooltip'),
      buttons: [{
        text: $t('ok-button'),
        click: function () {
          $container.dialog('close');
          $container.remove();
        }
      }]
    });
  } // Given a DSC (Digital Slide Conference) Id and Name, create a new conference and start listening for responses


  self.createNewConference = function (DscId, DscName) {
    var vil = $.getVilInstance();
    var vilDivId = vil.attr('id'); // we must have a VIL to ceate a conference

    var dst = vil.getDst();
    var vm = dst.getActiveViewModel();
    var dscSettings = {
      dscId: DscId,
      authToken: self.authToken(),
      fullName: self.fullName(),
      userId: self.userId(),
      vilDivId: vilDivId !== undefined ? vilDivId : 'vilContainer',
      dscName: DscName
    };

    if (vm) {
      var imagesState = vil.uScope.getImageState(); // before starting the conference, close all pinned images

      $.each(imagesState, function (i, val) {
        if (val.isPinned) {
          vm.closeSlide(val.imagePath); // use slide tray to coordinate closing the images
        }
      });
      vm.settings.displayMultiSlide = false; // turn off multislide

      vm.refreshSettings(vm); // force refresh of settings dependent dst UI
    } // start a conf manager with 'dsc name'


    self.createConfManager(DscId); // create the conference

    $().conference('create', dscSettings); // start checking to see if any users declined

    setInterval(function () {
      self.checkForInviteResponses(DscId);
    }, self.conferenceInvitationResponsePollingIntervalMS);
  }; // This will create a conference if one does not already exist and return the DSC Id and Name in the response


  self.sendConferenceInvites = function () {
    // get the dstInfo and send to server to be saved with conference
    // Conference recipients can then read this info when joining the conference
    // Note that if leader deletes slides during conference, this may not be reflected in followers session
    var dstInfo = self.getDSTInfoAsJson();
    $('<input>').attr({
      type: 'hidden',
      id: 'dstInfoId',
      name: 'dstInfo'
    }).val(dstInfo).appendTo('#DSCInviteForm');
    return $.post(self.saveDscURL, $('#DSCInviteForm').serialize(), null, 'json').fail(function (jqXHR, textStatus, errorThrown) {
      (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.add-dsc', {
        status: textStatus,
        error: errorThrown
      }));
    });
  };
  /**
   * Polling loop on the leader that continuously checks the DscInvitation table
   * for conference invitees who have responsed to the conference invite
   * @param dscId
   */


  self.checkForInviteResponses = function (dscId) {
    var $t = translate.scope('conference.chat');
    $.getJSON(self.getDscInviteResponseURL, {
      'DscId': dscId
    }).done(function (userResponses) {
      // Check for null before passing to .each()
      if (!userResponses || !userResponses.length) {
        return;
      } //response is an array of invitation objects, each of which represents a user who has responded to the conference invite (accept or decline)


      $.each(userResponses, function (index, invite) {
        var msg = invite.DeclineReason ? invite.DeclineReason : '',
            // if reponse message undefined, set it to empty string
        declining = _consts__WEBPACK_IMPORTED_MODULE_0__.INVITATION_STATUS.DECLINING == invite.Status,
            userName = invite['UpToUsersByUserId.FullName']; // Adds response message to the leaders chat window; If the user declines, show the word 'Declined.', plus any message.
        // If a user accepts, just show message. If no message, show 'Accepted.'

        circularClientVil.dscAddLineToChat(userName ? userName : $t('user') + invite.UserId, declining ? $t('declined') + msg : msg ? msg : $t('accepted')); // Set the status column in the DscInvitation table from declining/accepting to declined/accepted; This prevents the response message from being fetched multiple times

        invite.Status = declining ? _consts__WEBPACK_IMPORTED_MODULE_0__.INVITATION_STATUS.DECLINED : _consts__WEBPACK_IMPORTED_MODULE_0__.INVITATION_STATUS.ACCEPTED;
        $.post(self.setDscInviteResponseURL, invite); //
      });
    });
  };
  /**
   * Update the conferencing availablility indication UI
   * TODO: Remove UI specific logic, which violates SOC. Instead, raise an event for clients to handle -cb
   * @param status
   */


  self.setDscAvailIndicator = function (status) {
    $('.conferenceStatus i').removeClass('icon-circle');
    $('.DSCButtonGroup').removeAttr('checked');

    if (undefined === status) {
      status = _consts__WEBPACK_IMPORTED_MODULE_0__.UserDscAvailability.Available;
    }

    switch (parseInt(status)) {
      case parseInt(_consts__WEBPACK_IMPORTED_MODULE_0__.UserDscAvailability.Available):
        $('#dscAvailIndicator .DSCButtonGroup').prop('checked', true);
        $('#conferenceAvailable i').addClass('icon-circle');
        break;

      case parseInt(_consts__WEBPACK_IMPORTED_MODULE_0__.UserDscAvailability.Busy):
        $('#dscBusyIndicator .DSCButtonGroup').prop('checked', true);
        $('#conferenceBusy i').addClass('icon-circle');
        break;

      case parseInt(_consts__WEBPACK_IMPORTED_MODULE_0__.UserDscAvailability.Offline):
        $('#dscOfflineIndicator .DSCButtonGroup').prop('checked', true);
        $('#conferenceOffline i').addClass('icon-circle');
        break;
    }
  };
  /**
   * Get conferencing availability by user id
   * Used to set the little drop down conferencing dialog box status indicators
   * TODO: Figure out how to pass the parsed status in the returned promise
   * @param {type} userId
   * @param {type} disableCache
   * @returns {unresolved}
   */


  self.getDscAvailability = function (userId, disableCache) {
    if (typeof userId === 'undefined' || '' == userId) {
      userId = self.userId();
    }

    disableCache = disableCache || false;
    return $.post(self.getDscAvailabilityURL, {
      UserId: userId,
      DisableCache: disableCache
    }).done(function (response) {
      var status = response.hasOwnProperty('Status') ? response.Status : response; // eslint-disable-line no-prototype-builtins

      self.setDscAvailIndicator(status);
    }).fail(function (jqXHR, textStatus) {
      if (jqXHR.status === 400) {
        (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.save-dsc-availability', {
          status: textStatus
        }));
      }
    });
  };
  /**
   * Set conferencing availability
   * status declared, uninitialized === undefined
   * @param {type} status
   * @param {type} userid
   * @returns {unresolved}
   */


  self.setDscAvailability = function (status, userid) {
    var data = {};

    if (typeof status === 'undefined' || null === status || '' === status) {
      status = _consts__WEBPACK_IMPORTED_MODULE_0__.UserDscAvailability.Available;
    }

    if (window.__isAIH) {
      if (typeof userid === 'undefined') {
        userid = self.userId();
      } //data = {Records: {EntityBase: [{Id: userid, DscAvailability: status, "@attributes": {"xsi:type": "Users"}}]}};


      data = {
        Status: status
      };
    } else {
      data = {
        AJAX: true,
        SHC: true,
        Status: status
      };
    } // in pal mode, set the radio button here. setting it in the
    // sucess below is too slow and is confusing to the user.


    self.setDscAvailIndicator(status);
    $('#confBtn').trigger('hidePopover');
    return $.post(self.setDscAvailabilityURL, data).fail(function (jqXHR, textStatus) {
      if (jqXHR.status === 400) {
        (0,_utility__WEBPACK_IMPORTED_MODULE_1__.showMessage)(translate('conference.error.save-dsc-availability', {
          status: textStatus
        }));
      }
    });
  };

  self.setClientVil = function (clientVil) {
    circularClientVil = clientVil;
  };

  function postJSON(url, data) {
    return $.ajax({
      url: url,
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: data
    });
  }

  return self;
}

/***/ }),

/***/ "./src/client/ConferenceInvite.js":
/*!****************************************!*\
  !*** ./src/client/ConferenceInvite.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ConferenceInvite": () => (/* binding */ ConferenceInvite)
/* harmony export */ });
function ConferenceInvite($, events, translate, conference) {
  var self = {};
  self.inviteDivId = '_confInvite_';
  /**
   * Is the invitation dialog already open
   * @returns {Boolean}
   */

  self.inviteDialogIsOpen = function () {
    return $('#' + this.inviteDivId).dialog('isOpen') === true;
  };
  /*
   * Show the conference invitation dialog
   * @param dscId The id of the conference (table DSC)
   * @param description The description of the conference typed in by the leader (table DSC)
   * @param dscInvitationId The id of the dsc invitation record (table DscInvitation, formerly called DscUser)
   * @param leaderName The name of the conference leader
   */


  self.presentConfInviteDialog = function (dscId, description, dscInvitationId, leaderName) {
    // TODO: Set this up so the dialog is created anew each time and loads the html dynamically as part of the dialog
    // Then destroy the dialog after user acknowledges it via OK or cancel
    var $t = translate.scope('invite'); // display invitation dialog

    $('<div>', {
      'id': 'confInvite'
    }).load(conference.getDscInviteURL + ' .ResultsMain', function () {
      // setup the initial values of the dialog
      $(this).find('#dscInviteTextArea').val('');
      $('.dsc-invitation-message').text($t('has-invited-you'));
      $('.dsc-invite-textarea').attr('placeholder', $t('reply-conference-host-message'));

      if (leaderName === 'Someone') {
        leaderName = $t('someone');
      }

      $(this).find('#dscInvitorName').text(leaderName);
      $(this).find('#dscDescription').text(null !== description ? description : '');
    }).dialog({
      autoOpen: true,
      resizable: true,
      dialogClass: 'confInviteDlg',
      position: 'center',
      height: 400,
      width: 370,
      title: $t('invitation-title'),
      closeOnEscape: false,
      closeText: $t('close-tooltip'),
      buttons: [{
        text: $t('accept-button'),
        click: function () {
          const acceptMessage = $(this).find('#dscInviteTextArea').val();
          events.trigger('lbs-dsc-launch-webviewer-now', dscId, dscInvitationId, acceptMessage);
          $(this).dialog('close');
        }
      }, {
        text: $t('decline-button'),
        click: function () {
          var declineReason = $(this).find('#dscInviteTextArea').val();
          $(this).dialog('close');
          conference.declineConference(dscInvitationId, declineReason);
        }
      }],
      open: function () {
        // hide the X in the dialog title bar.
        $('.ui-dialog-titlebar-close').hide();
      },
      close: function () {
        $(this).dialog('destroy').remove();
      }
    });
  };
  /*
   * Close the conference invitation dialog
   */


  self.closeConfInviteDialog = function () {
    var dlg = $('.confInviteDlg');

    if (dlg.length > 0) {
      dlg.hide();
      dlg.dialog('close');
    }
  };

  return self;
}

/***/ }),

/***/ "./src/client/Connection.js":
/*!**********************************!*\
  !*** ./src/client/Connection.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createDscConnection": () => (/* binding */ createDscConnection)
/* harmony export */ });
/* harmony import */ var _Message__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Message */ "./src/client/Message.js");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./consts */ "./src/client/consts.js");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./logger */ "./src/client/logger.js");
/* harmony import */ var _xml_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./xml-utils */ "./src/client/xml-utils.js");
//------------------------------------------------------------------
// Description: The DSC Connection object encapsulates DSC communication protocol. DSC messaging protocol is based on
//              HTTP. There are 2 types of messages: requests and event updates. HTTP POST is used to send requests and
//				HTTP Long Polling is used for unsolicited event updates.
//              HTTP POST is used rather than GET for all requests since all requests contain Data XML node, the size of
//              which is really dictated by the application protocol and this could hit the GET size limits. By using POST
//              The application protocol can be kept independent of the communication protocol.
//              Conferencing also requires clients get event updates as they happen. Since HTTP is a request-response
//              protocol, an outstanding request is required to get any updates from server. To do this right, a mechanism
//              called long polling is used. Long polling (http://en.wikipedia.org/wiki/Push_technology#Long_polling) is a
//              mechanism where a request is made and the server responds when there is useable data available (or after an
//              appropriate timeout.) In our case the DSC message used for that standing request is "Register For Events".
//              This is the only message that this component sends and handles. The client of this component should never
//              send this message. The server on receipt of this message returns in response any event updates as a list of
//              forwarded messages or an empty message list. By grouping messages, the number of request responses are optimized
//              The timeout used here is 5 seconds (a property of the server.) This offers a good balance between lags or
//              extreme traffic introduced by regular polling.
//              The event update request uses a separate connection from the request/response connection. This avoids potential
//              lag in making client requests.
//              Use of AJAX also helps in not blocking client module.
//
// Author:      Kiran Saligrama
// Module Design:
//              setDSCURI: a method to set the relative URI for DSC Server. This is used with the window.location.host to
//                         build the complete URI. By default this is "dscserver"
//              addDSCMessageHandler: Whenever a response or event update is received by this component, a client specified message
//                                    handler is called. There can be more than one message handler per message type. All handlers for
//                                    the given message type are called when a response/update is received.
//              addDSCErrorHandler: Error handlers are called when there are errors at the message level or at the communication level.
//              sendDSCMessage: This method sends the client message if there are no outstanding requests. If there is an outstanding
//                              request, the message is queued.
//                              The "latest only" logic is implemented by replacing the previous message of that type. The latestMsgOnly
//                              array contains the mapping from messge type to latest only state.
//
//------------------------------------------------------------------




function createDscConnection(translate, messageQueue) {
  var ___DEBUG___ = false;
  var ___DEBUG2___ = false;
  var that = null;
  var xhr = null;
  var xhrEvent = null;
  var dscURL = '';
  var dscMessageHandlers = [[], []];
  var dscErrorHandlers = [];
  var latestMsgOnly = [];
  latestMsgOnly[_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage] = false;
  latestMsgOnly[_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confAttributeMessage] = false;
  latestMsgOnly[_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confImagePositionUpdateMessage] = true;
  latestMsgOnly[_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confMarkerPositionUpdateMessage] = true;
  latestMsgOnly[_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confEventUpdateRegistration] = false;
  var clientId = -1;
  return {
    setDSCURI: function (value) {
      dscURL = window.location.protocol + '//' + window.location.host + '/' + value + '/';
    },
    addDSCMessageHandler: function (msgType, handlerFunction) {
      if (msgType in dscMessageHandlers) dscMessageHandlers[msgType].push(handlerFunction);
    },
    addDSCErrorHandler: function (handlerFunction) {
      dscErrorHandlers.push(handlerFunction);
    },
    reset: function () {
      clientId = -1;
      if (xhr != null) xhr.abort();
      xhr = null;
      if (xhrEvent != null) xhrEvent.abort();
      xhrEvent = null;
      messageQueue.resetQueue();
      dscMessageHandlers = [[], []];
      dscErrorHandlers = [];
    },
    init: function () {
      that = this;
      xhr = createXHRObj();
      xhrEvent = createXHRObj();
      this.setDSCURI('dscserver');
    },
    sendDSCMessage: function (msgTitle, msgDataNode, msgType) {
      if (xhr == null) this.init();
      var msgObj = new _Message__WEBPACK_IMPORTED_MODULE_0__.Message(msgTitle, msgDataNode, msgType);

      if (isXHRBusy(xhr)) {
        messageQueue.addMessage(msgObj, latestMsgOnly[msgType] !== undefined ? latestMsgOnly[msgType] : false);
        return;
      }

      sendDSCMessageInt(msgObj, undefined, undefined);
    }
  };

  function isXHRBusy(inXHR) {
    if (inXHR !== null && inXHR.readyState !== 0 && inXHR.readyState !== 4) {
      return true;
    }

    return false;
  }
  /*
  *DSC message response handlers
  */


  function dscMessageSink() {
    //output response XML to debug div
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        if (xhr.responseXML != undefined) handleDSCResponse(xhr.responseXML);
      } else {
        for (var errHdlrInd = 0; errHdlrInd < dscErrorHandlers.length; errHdlrInd++) {
          dscErrorHandlers[errHdlrInd](_consts__WEBPACK_IMPORTED_MODULE_1__._dscErrorTypes.confNetError, null, null);
        }

        if (___DEBUG___ && document.getElementById('lastDSCReqResp') !== null) document.getElementById('lastDSCReqResp').innerHTML = translate('client-util.error.http-error', {
          status: xhr.status
        });
      }
    }
  }

  function handleDSCResponse(dscRespXML) {
    var dscRoot = dscRespXML.documentElement; //debug start

    var respClientId = parseInt(dscRoot.getElementsByTagName('To')[0].attributes.getNamedItem('Id').value, 10);
    if (clientId != -1 && respClientId != -1 && respClientId !== clientId) (0,_logger__WEBPACK_IMPORTED_MODULE_2__.dscConsoleLog)('#### Incorrect clientId. Recieved Id = ' + respClientId + ' Saved client id = ' + clientId); //debug end

    var respType = dscRoot.attributes.getNamedItem('Type').value;
    var statusNd = dscRoot.getElementsByTagName('Data')[0].getElementsByTagName('Status')[0].getElementsByTagName('Value')[0];

    if ((statusNd.textContent || statusNd.text) !== '0') {
      if (dscErrorHandlers != null) for (var errHdlrInd = 0; errHdlrInd < dscErrorHandlers.length; errHdlrInd++) {
        dscErrorHandlers[errHdlrInd](_consts__WEBPACK_IMPORTED_MODULE_1__._dscErrorTypes.confMsgError, respType, dscRoot);
      }
      return;
    } else if (___DEBUG2___) (0,_logger__WEBPACK_IMPORTED_MODULE_2__.dscConsoleLog)(respType + ' recieved');

    dscMessageRouter(respType, dscRoot);

    if (!isXHRBusy(xhr)) {
      var msgObj = messageQueue.getNextMessage();
      if (msgObj != null) sendDSCMessageInt(msgObj, undefined, undefined);
    }
  }

  function dscMessageRouter(respType, dscRoot) {
    if (respType == 'New Participant Response') {
      clientId = parseInt(dscRoot.getElementsByTagName('To')[0].attributes.getNamedItem('Id').value, 10);
      registerForEvent();
    }

    var dscMsgType;

    if (respType == 'Insert Conference Attribute' || respType == 'Update Conference Attribute' || respType == 'Delete Conference Attribute') {
      dscMsgType = _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confAttributeMessage;
    } else {
      dscMsgType = _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage;
    }

    for (var msgHdlrInd = 0; msgHdlrInd < dscMessageHandlers[dscMsgType].length; msgHdlrInd++) {
      dscMessageHandlers[dscMsgType][msgHdlrInd](respType, dscRoot);
    }
  }
  /************
   DSC Event registration and handler functions
   ************/


  function registerForEvent() {
    //send a register message	"Register For Events"
    //Create empty data node
    var msgDoc = createDSCMsgDocument('Register For Events');
    var dataNd = msgDoc.createElement('Data'); //create Data node

    var msgObj = new _Message__WEBPACK_IMPORTED_MODULE_0__.Message('Register For Events', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confEventUpdateRegistration); //that.sendDSCMessage("Register For Events", dataNd, xhrEvent, dscEventSink);

    xhrEvent = createXHRObj();
    sendDSCMessageInt(msgObj, xhrEvent, dscEventSink);
  }

  function dscEventSink() {
    //output response XML to debug div
    if (xhrEvent.readyState == 4) {
      var logDiv = document.getElementById('lastDSCEvent');

      if (xhrEvent.status && xhrEvent.status == 200) {
        if (xhrEvent.responseXML !== undefined) {
          var msg, msgList, msgInd;
          msgList = xhrEvent.responseXML.documentElement.getElementsByTagName('MVM_Message');

          for (msgInd = 0; msgInd < msgList.length; msgInd++) {
            msg = msgList[msgInd];
            if (logDiv && ___DEBUG___) logDiv.innerHTML += msg.attributes.getNamedItem('Type').value + '\n';
            var respType = msg.attributes.getNamedItem('Type').value;
            dscMessageRouter(respType, msg);
            if (___DEBUG2___) (0,_logger__WEBPACK_IMPORTED_MODULE_2__.dscConsoleLog)('Recieved message' + respType);
          }
        }

        registerForEvent();
      } else {
        for (var errHdlrInd = 0; errHdlrInd < dscErrorHandlers.length; errHdlrInd++) {
          dscErrorHandlers[errHdlrInd](_consts__WEBPACK_IMPORTED_MODULE_1__._dscErrorTypes.confNetError, null, null);
        }

        if (logDiv) logDiv.innerHTML = translate('client-util.error.http-error', {
          status: xhr.status
        });
      }
    }
  }
  /************
   Generic DSC message utility functions
   ************/


  function sendDSCMessageInt(msgObj, xhrObject, respHandler) {
    if (xhr == null) that.init(); //Create MVM message document

    var msgDoc = createDSCMsgDocument();
    msgDoc.documentElement.setAttribute('Type', msgObj.getTitle()); //set message type

    const ndFrom = msgDoc.createElement('From'); //Add From node

    ndFrom.setAttribute('Id', String(clientId));
    msgDoc.documentElement.appendChild(ndFrom);
    const ndTo = msgDoc.createElement('To'); //add To node

    ndTo.setAttribute('Id', '0');
    msgDoc.documentElement.appendChild(ndTo);
    msgDoc.documentElement.appendChild(msgObj.getDataNode()); //add Data node

    var xhrToUse = xhrObject === undefined ? xhr = createXHRObj() : xhrObject;

    if (xhrToUse) {
      if (xhrToUse.readyState != 0) xhrToUse.abort();
      xhrToUse.open('POST', dscURL + clientId + Math.floor(Math.random() * 10000), true);
      xhrToUse.setRequestHeader('Content-type', 'text/xml; charset=utf-8');
      xhrToUse.responseType = 'document';
      if (respHandler === undefined) xhrToUse.onreadystatechange = dscMessageSink;else xhrToUse.onreadystatechange = respHandler;
      xhrToUse.send(msgDoc);
      if (___DEBUG2___) (0,_logger__WEBPACK_IMPORTED_MODULE_2__.dscConsoleLog)('Sent message' + msgObj.getTitle());
    }
  }

  function createDSCMsgDocument(msgType) {
    var xmlDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_3__.createXMLDocument)('MVM_Message');
    xmlDoc.documentElement.setAttribute('Type', msgType);
    return xmlDoc;
  }

  function createXHRObj() {
    return new XMLHttpRequest();
  }
}

/***/ }),

/***/ "./src/client/Message.js":
/*!*******************************!*\
  !*** ./src/client/Message.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Message": () => (/* binding */ Message)
/* harmony export */ });
class Message {
  constructor(msgTitle, msgDataNode, msgType) {
    this._msgTitle = msgTitle;
    this._msgDataNode = msgDataNode;
    this._msgType = msgType;
  }

  getType() {
    return this._msgType;
  }

  getDataNode() {
    return this._msgDataNode;
  }

  getTitle() {
    return this._msgTitle;
  }

}

/***/ }),

/***/ "./src/client/MessageQueue.js":
/*!************************************!*\
  !*** ./src/client/MessageQueue.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MessageQueue": () => (/* binding */ MessageQueue)
/* harmony export */ });
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./consts */ "./src/client/consts.js");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./logger */ "./src/client/logger.js");
//------------------------------------------------------------------
// Description: Message queue object. The client interface component queues up messages till a response to the previous
//              message is received. This prevents current message clobbering the response from previous message and
//				also allows the application to not block.
//              This object is used exclusively by internal DSC client communication object.
//              Message queue component queues a message object type. A message object type can be created by the msgMaker
//              function.
//              This component does NOT guarantee message order. Specifically when a message is tagged latest only, it
//              REPLACES an already existing such message and potentially putting it ahead of other messages in the Queue. This
//              is the only case where order is not preserved. In all other cases, order is preserved.
// Author:      Kiran Saligrama
// Interface Description:
//              addMessage: Add a message to the queue. If the latest only flag is set, the last message with the same title is
//                          replaced else the message is added to the end of the queue.
//              getNextMessage: Returns the next message to be sent from the front of the Queue.
//              getQueueLength: Returns the message count currently in the Queue. Mostly used for debugging.
//              resetQueue: Clears the message Queue.
//
//------------------------------------------------------------------


const ___DEBUG2___ = false;
function MessageQueue() {
  var privMsgQueue = [];
  var lastIndex = [];
  lastIndex[_consts__WEBPACK_IMPORTED_MODULE_0__._dscMessageTypes.confManagementMessage] = -1;
  lastIndex[_consts__WEBPACK_IMPORTED_MODULE_0__._dscMessageTypes.confAttributeMessage] = -1;
  lastIndex[_consts__WEBPACK_IMPORTED_MODULE_0__._dscMessageTypes.confImagePositionUpdateMessage] = -1;
  lastIndex[_consts__WEBPACK_IMPORTED_MODULE_0__._dscMessageTypes.confMarkerPositionUpdateMessage] = -1;
  lastIndex[_consts__WEBPACK_IMPORTED_MODULE_0__._dscMessageTypes.confEventUpdateRegistration] = -1;

  function decrementIndicies() {
    for (var ind = 0; ind < lastIndex.length; ind++) {
      if (lastIndex[ind] >= 0) lastIndex[ind] -= 1;
    }
  }

  return {
    addMessage: function (msgObj, latestOnly) {
      var addInd = -1;
      var msgType = msgObj.getType();

      if (latestOnly) //if latest only, figure out index of last queued msg (if any)
        {
          if (lastIndex[msgType] === undefined) //unknown type, just add to end of queue
            addInd = -1;else addInd = lastIndex[msgType];
        }

      if (addInd === -1) {
        privMsgQueue[privMsgQueue.length] = msgObj;
        addInd = privMsgQueue.length - 1; //the index itself one less than the length
      } else privMsgQueue[addInd] = msgObj;

      if (latestOnly && lastIndex[msgType] !== undefined) //remember index of latest only message
        lastIndex[msgType] = addInd;
      if (___DEBUG2___) (0,_logger__WEBPACK_IMPORTED_MODULE_1__.dscConsoleLog)('added message ' + msgObj.getTitle() + ' to the queue at index ' + addInd);
    },
    getNextMessage: function () {
      if (privMsgQueue.length === 0) return null;
      var nxtMsg = privMsgQueue[0];
      privMsgQueue.splice(0, 1);
      decrementIndicies();
      if (___DEBUG2___) (0,_logger__WEBPACK_IMPORTED_MODULE_1__.dscConsoleLog)('returned message ' + nxtMsg.getTitle());
      return nxtMsg;
    },
    getQueueLength: function () {
      return privMsgQueue.length;
    },
    resetQueue: function () {
      privMsgQueue = [];
    }
  };
}

/***/ }),

/***/ "./src/client/confEvents.js":
/*!**********************************!*\
  !*** ./src/client/confEvents.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "confEvent": () => (/* binding */ confEvent)
/* harmony export */ });
//________________________________________________________________________________________________
//	This file contains the names of the conference events and documents each event's contents.
//
//	Notes:
//		- The conference events are triggered at the document level
//		- A conference event always contains a source component, for example VIL, DST or uScope.
//
const confEvent = {
  //............................................................................................
  // VIL issued events
  //............................................................................................
  // VIL fires a create event when it communicates conference start to the DSC server
  create: 'cf_create' // {src: "VIL", tbd: fill me in }
  // VIL fires a join message when the viewer is to enter conferencing mode
  // DST and uScope listen for this message and configure according to whether they are the leader or not
  ,
  join: 'cf_join' // {src: "VIL", lead: {true,false}, userName: STR }
  // VIL fires a lead message when the leadership role changes
  // DST and uScope listen for this message and configure according to whether they are the leader or not
  ,
  leadChange: 'cf_lead' // {src: "VIL", lead: {true,false} }
  // VIL fires an exit message when the viewer is exiting the conference
  // DST and uScope listen for this message and return to non-conference operation
  ,
  exit: 'cf_exit' // {src: "VIL" }
  //............................................................................................
  // uScope issued events
  //............................................................................................
  // as a conference leader, uScope fires the open or close event to report image open or close events
  // The leader uScope fires it, the follower uScope listens for it (issued by follower VIL)
  ,
  openimage: 'cf_openimage' // {src: "uScope", imageId: @NUM, uScopeIdx: NUM, "imagePath": STR }
  ,
  closeimage: 'cf_closeimage' // {src: "uScope", imageId: @NUM }
  // uScope fires a createBtn event when the user clicks the conference button on uScope's toolbar
  // VIL listens for it and creates the conference
  ,
  createBtn: 'cf_createBtn' // {src: "uScope" }
  // as a conference leader, uScope fires the marker event to report the user's cursor position
  ,
  marker: 'cf_marker' // {src: "uScope", imageId: @NUM, uScopeIdx: NUM, "imagePath": STR, MarkerX: NUM, MarkerY: NUM }
  ///	, Marker: "Marker"			// match event name with DSC client's string that filters out prior messages
  // as a conference leader, uScope fires the view event to report the view state changes
  // ! note that when multi-image is implemented this signature will probably expand to include all the open images
  ,
  view: 'cf_view' // {src: "uScope", imageId: @NUM, uScopeIdx: NUM, "imagePath": STR, x: NUM, x: NUM, zoom: NUM, angleDeg: NUM }
  ///	, Position: "Position"		// match event name with DSC client's string that filters out prior messages
  // as a conference follower, uScope listens for this event (issued by follower VIL)
  ,
  update: 'cf_update' // {src: "uScope", imageId: @NUM, ... (contents of position or marker events }
  // as a conference follower, uScope fires this event when its image has been changed
  // VIL listens for it and creates the conference
  ,
  imageChange: 'cf_imageChange' // {src: "uScope", imageId: @NUM }

};

/***/ }),

/***/ "./src/client/consts.js":
/*!******************************!*\
  !*** ./src/client/consts.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_dscMessageTypes": () => (/* binding */ _dscMessageTypes),
/* harmony export */   "_dscErrorTypes": () => (/* binding */ _dscErrorTypes),
/* harmony export */   "_conferenceTypes": () => (/* binding */ _conferenceTypes),
/* harmony export */   "UserDscAvailability": () => (/* binding */ UserDscAvailability),
/* harmony export */   "INVITATION_STATUS": () => (/* binding */ INVITATION_STATUS)
/* harmony export */ });
/**
 * Message type enum definition. This is used by the client interface to decide whether all messages should be sent or
 * only the latest. See comments for mapping.
 * @type {{
 *   confMarkerPositionUpdateMessage: number,
 *   confManagementMessage: number,
 *   confEventUpdateRegistration: number,
 *   confAttributeMessage: number,
 *   confImagePositionUpdateMessage: number
 * }}
 */
const _dscMessageTypes = {
  confManagementMessage: 0,
  // send all messages
  confAttributeMessage: 1,
  // send all messages
  confImagePositionUpdateMessage: 2,
  // send only latest message
  confMarkerPositionUpdateMessage: 3,
  // send only latest message
  confEventUpdateRegistration: 4 // send only latest

};
const _dscErrorTypes = {
  confMsgError: 0,
  //application level error
  confNetError: 1 //network error sending message

};
const _conferenceTypes = {
  CASE: 'Case',
  STUDY: 'Study'
};
/**
 * Values for the DscAvailability column in the Users table. These are the status values that
 * are returned from GetDSCUser (which returns rows from the Users table)
 */

const UserDscAvailability = {
  /**
   * user is available
   */
  Available: '0',

  /**
   * user is busy
   */
  Busy: '1',

  /**
   * user is offline
   */
  Offline: '2',

  /**
   * Conferencing not allowed, e.g. role doesn't permit it, or running in eSM (which doesn't support conferencing)
   */
  NotAllowed: '4'
};
/**
 * DscInvitation table status values
 */

const INVITATION_STATUS = {
  /**
   * user is avaiable
   */
  AVAILABLE: '0',

  /**
   * user is invited
   */
  INVITED: '1',

  /**
   * user has accepted
   */
  ACCEPTED: '2',

  /**
   * user has declined, but message has not yet been read from server
   */
  DECLINING: '3',

  /**
   * leader has been informed of the decline
   */
  DECLINED: '4',

  /**
   * User clicked accept, but message gas not yet been read from server
   */
  ACCEPTING: '5'
};

/***/ }),

/***/ "./src/client/jquery.conference.js":
/*!*****************************************!*\
  !*** ./src/client/jquery.conference.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "initJQueryPlugin": () => (/* binding */ initJQueryPlugin)
/* harmony export */ });
/* harmony import */ var _confEvents__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./confEvents */ "./src/client/confEvents.js");
/* harmony import */ var _consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./consts */ "./src/client/consts.js");
/* harmony import */ var _xml_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./xml-utils */ "./src/client/xml-utils.js");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./logger */ "./src/client/logger.js");




/*
 * Digital Slide Conferencing jQuery plugin
 */

function initJQueryPlugin($, events, leica, conferenceObj, g_dscClient, clientVil) {
  if ($.fn.conference) {
    console.warn('jQuery conferencing plugin already initialized.'); // todo: remove

    return;
  }

  $.fn.conference = function (method) {
    const _participant = clientVil._participant; // _participant used to be a global var
    // name space for bound digital slide conference events

    var eventNameSpace = '.dsc';
    /*
     * conference API methods
     */

    var methods = {
      init: confInit,
      create: confCreate,
      join: confJoin,
      close: confClose
    };

    if (methods[method]) {
      // a known method is being called, call it and pass arguments[1..n]
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      // Default to 'init' method
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method "' + method + '" does not exist in jQuery.conference');
    }
    /********************************************************************************************
     * conference API method implementations
     ********************************************************************************************/

    /**
     * Conference invitation
     * @param participant
     * @returns object
     */


    function confInit(participant) {
      (0,_logger__WEBPACK_IMPORTED_MODULE_3__.dscConsoleLog)('confInit');

      if (participant) {
        $.extend(_participant, participant);
      }

      return this;
    }
    /*
     * Create a conference
     * @param object DSCSettings = {
     *          authToken:
     *          confManagerDivId:
     *          dscId:
     *          dscName:
     *          fullName:
     *          userId:
     *          vilDivId:
     *          }
     * @returns this
     */


    function confCreate(DSCSettings) {
      (0,_logger__WEBPACK_IMPORTED_MODULE_3__.dscConsoleLog)('confCreate');
      clientVil.resetParticipant(true);
      addConfMessageHandlers();
      _participant.isLeader = true;
      bindConfEvents(); // createConference is in DSCClientVil.js

      clientVil.createConference(DSCSettings);
      return this;
    }
    /*
     * Join a conference
     * @param object DSCSettings = {
     *          authToken:
     *          confManagerDivId:
     *          dscId:
     *          dscName:
     *          fullName:
     *          userId:
     *          vilDivId:
     *          }
     * @returns this
     */


    function confJoin(DSCSettings) {
      (0,_logger__WEBPACK_IMPORTED_MODULE_3__.dscConsoleLog)('confJoin');
      clientVil.resetParticipant(true);
      addConfMessageHandlers(); // joinConference is in DSCClientVil.js
      // NOTE!!! This has same name as joinConference in conference.js

      clientVil.joinConference(DSCSettings); // tell uScope leader join the conference

      if (_participant.isLeader) {
        $(document).trigger(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.join, {
          src: 'Vil',
          lead: _participant.isLeader,
          userName: _participant.ptName
        });
      }

      return this;
    }
    /*
     * Close a conference
     * @returns this
     */


    function confClose() {
      (0,_logger__WEBPACK_IMPORTED_MODULE_3__.dscConsoleLog)('confClose'); // unbind the conference events

      _participant.isLeader = false;
      bindConfEvents(); // leaveConference is in DSCClientVil.js

      return clientVil.leaveConference();
    }
    /********************************************************************************************
     * private methods
     ********************************************************************************************/

    /*
     * add the conference message handlers
     */


    function addConfMessageHandlers() {
      g_dscClient.addDSCMessageHandler(_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage, confMessageRouter);
      g_dscClient.addDSCMessageHandler(_consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confAttributeMessage, confMessageRouter);
    }
    /*
     * Conference message router.
     * Receives conference messages and responses, and triggers events based on the response
     *
     * @param string respType
     * @param XML dscRoot
     */


    function confMessageRouter(respType, dscRoot) {
      (0,_logger__WEBPACK_IMPORTED_MODULE_3__.dscConsoleLog)('jquery.conference.js message router: ' + respType);
      let json;

      switch (respType) {
        case 'New Conference Response':
          // trigger a join conference, which is what uScope is waiting for
          if (_participant.isLeader) {
            var confObject = {
              src: 'Vil',
              lead: _participant.isLeader,
              userName: _participant.ptName
            };
            $(document).trigger(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.join, confObject); // set the conference type and record using the conference module

            _participant.conferenceType = _consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.CASE;
            _participant.conferenceTopLevelPrimaryKey = conferenceObj.dstCurrentRecordId(); // tell the conference server the type of conference and the primary key for top level hierarchy

            sendConfTypeInformationAttributeJson(_participant);
          }

          break;

        case 'Join Conference Response':
          bindConfEvents();

          if (!_participant.isLeader) {
            // now send a Get Conference Attribute message
            sendGetConferenceAttributeMessage();
          }

          break;

        case 'Get Conference Attributes Response':
          if (!_participant.isLeader) {
            //get the conference type and primary key from dsc
            var conferenceInfo = getConfTypeAttributeJson(dscRoot); // Update the participant information

            _participant.conferenceType = conferenceInfo._ConferenceType;
            _participant.conferenceTopLevelPrimaryKey = conferenceInfo._ConferenceTopLevelPrimaryKey;

            switch (_participant.conferenceType) {
              case _consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.CASE:
                events.trigger('lbs-dsc-get-conf-attr-resp', dscRoot, buildConfImageAttributeJson, _participant.conferenceTopLevelPrimaryKey, _participant.confId, _participant.ptUserId, conferenceObj.userId(), conferenceObj.fullName(), conferenceObj.authToken());
                break;

              case _consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.STUDY:
                // Load peerreview conferencing stuff if not already present
                // TODO: retrieve asset URLs via ajax call to server? Alternatively, move this app specific code out of conferencing package
                var promise1 = {},
                    promise2 = {}; // note that $.when will treat a plain JS object as a resolved deferred
                // If something needs to load before the peer review conferencing js, use promise1

                if (typeof leica.pi.peerreview === 'undefined') {
                  var docRoot = '/packages/leica/'; //$('<link rel="stylesheet" type="text/css" href="' + docRoot + 'peerreview/stylesheets/peerreview.css" >').appendTo("head");

                  promise2 = $.when(promise1).then(function () {
                    return $.getScript(docRoot + 'peerreview/javascripts/peerreview-conferencing.js');
                  });
                } // When everything needed has been loaded, launch the conference


                $.when(promise1, promise2).done(function () {
                  leica.pi.peerreview.conferencing.createPeerReviewPopUpConference(dscRoot, buildConfImageAttributeJson, _participant.conferenceTopLevelPrimaryKey, _participant.confId, _participant.ptUserId, conferenceObj.userId(), conferenceObj.fullName(), conferenceObj.authToken());
                }).fail(function () {
                  console.log('Error: Unable to load peer review conferencing assets.');
                });
                break;
            }
          }

          break;

        case 'Close Conference Response':
          $(document).trigger(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.exit, {
            src: 'Vil'
          });
          break;

        case 'Insert Conference Attribute':
        case 'Update Conference Attribute':
          if (!_participant.isLeader) {
            json = buildConfImageAttributeJson($(dscRoot));
            $(document).trigger(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.update, json);
          } else {
            if (_consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.STUDY === _participant.conferenceType) {
              leica.pi.peerreview.conferencing.becameLeader();
            } else {
              leica.pi.esm.conferencing.becameLeader();
            }
          }

          break;

        case 'New Leader':
          var newLeaderName = dscRoot.getElementsByTagName('Participant')[0].attributes.getNamedItem('Name').value;
          _participant.isLeader = _participant.ptName === newLeaderName;
          json = {
            src: 'Vil',
            lead: _participant.isLeader
          };
          $(document).trigger(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.leadChange, json);
          bindConfEvents();
          break;

        case 'Assign Leadership Response':
          //the leader has assigned control -- becoming a follower
          if (_consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.STUDY === _participant.conferenceType) {
            leica.pi.peerreview.conferencing.becameFollower();
          } else {
            leica.pi.esm.conferencing.becameFollower();
          }

          break;

        case 'Grab Leadership Response':
          //the leader has taken back control
          if (_consts__WEBPACK_IMPORTED_MODULE_1__._conferenceTypes.STUDY === _participant.conferenceType) {
            leica.pi.peerreview.conferencing.becameLeader();
          } else {
            leica.pi.esm.conferencing.becameLeader();
          }

          break;
        // these messages are unused
        // cindy says that these messages come from DSC
        // but do not need to be handled here
        // they are handled in dscclientvil.js

        case 'New Participant Response':
        case 'List Conferences Response':
        case 'Insert Conference Attribute Response':
        case 'Update Conference Attribute Response':
        case 'Delete Conference Attribute Response':
        case 'Leave Conference Response':
        case 'Add Participant':
          break;
      }
    }
    /*
     * Send conference type attribute JSON
     * This message tells the conference server what type of conference [Case,Study] is being used
     *  TODO: refactor; this function has global side effects
     */


    function sendConfTypeInformationAttributeJson(p) {
      if (!p.isLeader) {
        return;
      }

      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var plistNd = buildPathListNode(msgDoc, '//Attribute_List');
      var alistNd = buildAttrListNode(msgDoc);
      var confTypeNode = buildConferenceTypeNode(msgDoc, p.conferenceType);
      alistNd.appendChild(confTypeNode);
      var confTopLevelPkNode = buildConferenceTopLevelPrimaryKeyNode(msgDoc, p.conferenceTopLevelPrimaryKey);
      confTypeNode.appendChild(confTopLevelPkNode); // use this type to insure this message is sent

      var msgType = _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confAttributeMessage;
      sendConferenceAttributeMessage('Insert', plistNd, alistNd, msgType);
    }
    /*
     * get conferencing attribute JSON
     *
     * @param DOM node
     * @returns json
     */


    function getConfTypeAttributeJson(node) {
      var json = {
        src: 'Vil'
      };
      var confType = $(node).find('ConferenceType');
      var confPrimaryKey = $(node).find('ConferenceTopLevelPrimaryKey');

      if (confType.length > 0) {
        $.extend(json, xml2json(confType[0]));
      }

      if (confPrimaryKey.length > 0) {
        $.extend(json, xml2json(confPrimaryKey[0]));
      }

      return json;
    }
    /*
     * build attribute JSON
     *
     * @param DOM element node
     * @returns json
     */


    function buildConfImageAttributeJson(node) {
      var json = {
        src: 'Vil'
      };
      var position = $(node).find('Position');
      var marker = $(node).find('Marker');
      var angleDeg = $(node).find('angleDeg');

      if (position.length > 0) {
        $.extend(json, xml2json(position[0]));
      }

      if (marker.length > 0) {
        $.extend(json, xml2json(marker[0]));
      }

      if (angleDeg.length > 0) {
        $.extend(json, xml2json(angleDeg[0]));
      }

      return json;
    }
    /*
     * event handlers for conference events that are triggered by uScope
     */


    function bindConfEvents() {
      // following events are for the leader only
      if (_participant.isLeader) {
        // as the leader, unbind the follower conference events
        $(document).off(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.imageChange + eventNameSpace); // the following events are needed by the leader only

        $(document).on(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.openimage + eventNameSpace, function (event, parms) {
          (0,_logger__WEBPACK_IMPORTED_MODULE_3__.dscConsoleLog)('confEvent.openimage x = ' + parms.x + ' y = ' + parms.y + ' zoom = ' + parms.zoom + ' angle = ' + parms.angleDeg + ' url = ' + parms.imagePath);
          sendViewOpenMessage(parms);
        });
        $(document).on(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.view + eventNameSpace, function (event, parms) {
          sendViewChangeMessage(parms);
        }); // as a conference leader, uScope fires the marker event to report the user's cursor position
        // The leader uScope fires it, the follower uScope listens for it (issued by follower VIL)

        $(document).on(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.marker + eventNameSpace, function (event, parms) {
          sendMarkerChangeMessage(parms);
        });
      } else {
        // not the leader, unbind the leader conference events
        $(document).off(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.view + eventNameSpace).off(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.marker + eventNameSpace); // as a conference follower, uScope fires the imageChange event to report that a new image has been opened by the leader
        // The response is to inform the follower slide tray to select the specified image
        //      parms: {src: "uScope", imageId: @NUM }

        $(document).on(_confEvents__WEBPACK_IMPORTED_MODULE_0__.confEvent.imageChange + eventNameSpace, function (event, parms) {
          $.getDstInstance().selectImageByImageId(parms.imageId.substring(1));
        });
      }
    }

    function sendViewChangeMessage(parms) {
      if (!_participant.isLeader) {
        return;
      }

      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var plistNd = buildPathListNode(msgDoc, '//Attribute_List/Image[1]/Position[1]');
      var alistNd = buildAttrListNode(msgDoc);
      var posNd = buildPositionNode(msgDoc, parms); // image position

      alistNd.appendChild(posNd);
      var msgType = _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confImagePositionUpdateMessage; // use this type to signal DSC to send the latest of this type

      sendConferenceAttributeMessage('Update', plistNd, alistNd, msgType); // send the position update conference attribute message
    }

    function sendMarkerChangeMessage(parms) {
      if (!_participant.isLeader) {
        return;
      }

      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var plistNd = buildPathListNode(msgDoc, '//Attribute_List/Image[1]/Marker[1]');
      var alistNd = buildAttrListNode(msgDoc);
      var mrkNd = buildMarkerNode(msgDoc, parms);
      alistNd.appendChild(mrkNd);
      var msgType = _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confMarkerPositionUpdateMessage; // use this type to signal DSC to send the latest of this type

      sendConferenceAttributeMessage('Update', plistNd, alistNd, msgType); // send the position update conference attribute message
    } //
    // open uScope conference - soon to be deprecated
    //


    function sendViewOpenMessage(parms) {
      if (!_participant.isLeader) {
        return;
      }

      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var plistNd = buildPathListNode(msgDoc, '//Attribute_List');
      var alistNd = buildAttrListNode(msgDoc);
      var imgNode = buildImageNode(msgDoc, parms); // image path

      alistNd.appendChild(imgNode);
      var posNd = buildPositionNode(msgDoc, parms); // image position

      imgNode.appendChild(posNd);
      var mrkNd = buildMarkerNode(msgDoc, parms); // marker

      imgNode.appendChild(mrkNd);
      var msgType = _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confAttributeMessage; // use this type to insure this message is sent

      sendConferenceAttributeMessage('Insert', plistNd, alistNd, msgType); // send the open image conference attribute message
    }

    function sendGetConferenceAttributeMessage() {
      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var dataNd = msgDoc.createElement('Data');
      g_dscClient.sendDSCMessage('Get Conference Attributes', dataNd, _consts__WEBPACK_IMPORTED_MODULE_1__._dscMessageTypes.confManagementMessage);
    }

    function buildPathListNode(msgDoc, textContent) {
      var plistNd = msgDoc.createElement('Path_List');
      var pathNd = msgDoc.createElement('Path');
      (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(pathNd, textContent); //  pathNd.textContent = "//Attribute_List";

      plistNd.appendChild(pathNd);
      return plistNd;
    }

    function buildAttrListNode(msgDoc) {
      var alistNd = msgDoc.createElement('Attribute_List');
      return alistNd;
    }

    function buildPositionNode(msgDoc, parms) {
      var posNd = msgDoc.createElement('Position');

      for (var prop in parms) {
        if (typeof parms[prop] != 'undefined') {
          // parms[prop] could be zero, with is falsy, so test for undefined explicitly
          var element = msgDoc.createElement(prop);
          (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(element, parms[prop]);
          posNd.appendChild(element);
        }
      }

      return posNd;
    }

    function buildMarkerNode(msgDoc, parms) {
      var mrkNd = msgDoc.createElement('Marker');

      for (var prop in parms) {
        if (typeof parms[prop] != 'undefined') {
          // parms[prop] could be zero, with is falsy, so test for undefined explicitly
          var element = msgDoc.createElement(prop);
          (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.setXMLNodeText)(element, parms[prop]);
          mrkNd.appendChild(element);
        }
      }

      return mrkNd;
    }

    function buildConferenceTypeNode(msgDoc, confType) {
      var conferenceTypeNode = msgDoc.createElement('ConferenceType');
      conferenceTypeNode.setAttribute('ConferenceType', confType);
      return conferenceTypeNode;
    }

    function buildConferenceTopLevelPrimaryKeyNode(msgDoc, key) {
      var confTopLevelPkNode = msgDoc.createElement('ConferenceTopLevelPrimaryKey');
      confTopLevelPkNode.setAttribute('ConferenceTopLevelPrimaryKey', key);
      return confTopLevelPkNode;
    }

    function buildImageNode(msgDoc, parms) {
      var imgNode = msgDoc.createElement('Image');
      imgNode.setAttribute('ImagePath', parms.imagePath);
      return imgNode;
    }

    function sendConferenceAttributeMessage(attributeAction, pathListNode, attributeListNode, msgType) {
      var msgTitle = attributeAction + ' Conference Attribute';
      var msgDoc = (0,_xml_utils__WEBPACK_IMPORTED_MODULE_2__.createXMLDocument)('temp');
      var dataNd = msgDoc.createElement('Data');
      dataNd.appendChild(pathListNode);
      dataNd.appendChild(attributeListNode);
      g_dscClient.sendDSCMessage(msgTitle, dataNd, msgType);
    }
  }; // Weird hack. eSM provides jQuery, which is shared between eSM, Conf, and WebViewer. WebViewer provides X2js, which
  // is only used by Conf and WebViewer.


  let x2js;

  function xml2json(arg) {
    if (!x2js) {
      x2js = new window.X2JS();
    }

    return x2js.xml2json(arg);
  }
}

/***/ }),

/***/ "./src/client/logger.js":
/*!******************************!*\
  !*** ./src/client/logger.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dscConsoleLog": () => (/* binding */ dscConsoleLog)
/* harmony export */ });
function dscConsoleLog(msg) {
  if (window.console) console.log(msg);
}

/***/ }),

/***/ "./src/client/utility.js":
/*!*******************************!*\
  !*** ./src/client/utility.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "showMessage": () => (/* binding */ showMessage)
/* harmony export */ });
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./logger */ "./src/client/logger.js");
/**
 * Extend jQuery with ajax method dedicated to POSTing JSON
 */

/**
 * Show a message to the user
 * @param message
 */

function showMessage(message) {
  try {
    if (typeof message === 'object') {
      var extractedMessage = 'title' in message ? message.title + ': ' : '' + ('text' in message) ? message.text : JSON.stringify(message);
      alert(extractedMessage);
    } else {
      alert(message);
    }
  } catch (err) {
    //swallow errors during alert
    // something went really wrong
    (0,_logger__WEBPACK_IMPORTED_MODULE_0__.dscConsoleLog)(err);
  }
}

/***/ }),

/***/ "./src/client/xml-utils.js":
/*!*********************************!*\
  !*** ./src/client/xml-utils.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createXMLDocument": () => (/* binding */ createXMLDocument),
/* harmony export */   "setXMLNodeText": () => (/* binding */ setXMLNodeText)
/* harmony export */ });
/************
 Generic DSC message utility functions
 ************/
function createXMLDocument(title) {
  return document.implementation.createDocument('', title, null);
}
const setXMLNodeText = function () {
  var txtNodeName = createXMLDocument('temp').documentElement.text === undefined ? 'textContent' : 'text';
  return function (nd, txt) {
    nd[txtNodeName] = txt;
    return nd;
  };
}();

/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js!./src/client/conference.css":
/*!*************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js!./src/client/conference.css ***!
  \*************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js */ "./node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\r\n* CSS for conferencing.\r\n* NOTE, the  ! importants are necessary because this css file\r\n* is loaded before the viewer css files. And the sizes in the\r\n* viewer css aren't correct with bootstrap\r\n*/\r\n#confSetupDialog {\r\n    height: 245px ! important;\r\n    overflow-y: hidden;\r\n    overflow-x: hidden;\r\n}\r\n\r\n#DSCInviteForm {\r\n    margin: 0px ! important;\r\n}\r\n\r\n#dscInviteTextArea {\r\n    width: 90%;\r\n    margin-left: 10px;\r\n    margin-top: 10px;\r\n    height: 140px;\r\n    resize: none;\r\n}\r\n\r\n#dscInvitorName {\r\n    font-weight: bold;\r\n}\r\n\r\n#dscPopup {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    overflow: hidden;\r\n    margin: 0;\r\n    background: #fff;\r\n    z-index: 100;\r\n}\r\n\r\n#dscUserListDiv {\r\n    border: 1px solid #A5A5A5;\r\n    height: 80px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n#dscUserListDiv ul {\r\n    margin-left: 5px ! important;\r\n    padding: 0;\r\n}\r\n\r\n#prtListId {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin-left: 5px ! important;\r\n    margin-right: 5px ! important;\r\n}\r\n\r\n.dscImg {\r\n    margin-left: 5px ! important;\r\n    margin-right: 5px ! important;\r\n}\r\n\r\n.dscUserListItem {\r\n    float: left;\r\n    font-size: 14px;\r\n    width: 100%;\r\n    list-style-type: none;\r\n}\r\n\r\n#dscMsgTextArea {\r\n    height: 110px;\r\n    margin-top: 8px;\r\n    resize: none;\r\n    width: 100%;\r\n}\r\n\r\n.dscHeader {\r\n    color: #666666;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n}\r\n\r\n.dscUserCheckbox {\r\n    margin-left: 5px ! important;\r\n    margin-right: 5px ! important;\r\n}\r\n\r\n/*\r\n* CSS for conferencing.\r\n*  The styles below came from ESM code:\r\n*       htdocs\\CSS\\DSC.css\r\n*  All conferencing styles are centralized here and both code\r\n*  bases use the same js functions for creating dialogs\r\n*/\r\ndiv[aria-describedby=\"confManager\"] {\r\n    min-width: 355px;\r\n}\r\n\r\n#confManager {\r\n    overflow: auto;\r\n    height: 490px;\r\n    width: 265px;\r\n}\r\n\r\n.confBtn.ui-widget {\r\n    float: right;\r\n    font-size: 10px;\r\n    margin-left: 2px;\r\n    margin-top: 4px;\r\n}\r\n\r\n.dscHeaderImg {\r\n    padding: 5px;\r\n    vertical-align: middle;\r\n}\r\n\r\n#prtListId li:nth-child(even) {\r\n    background: #EFEFEF;\r\n}\r\n\r\n#prtListId li {\r\n    font-size: 12px;\r\n    margin: 2px;\r\n}\r\n\r\n#prtListDiv {\r\n    border: #D1D1D1 solid 1px;\r\n    height: 175px;\r\n    margin: 0px;\r\n    overflow: auto;\r\n}\r\n\r\n#outgoingChatBox {\r\n    width: 97%;\r\n    height: 50px;\r\n    resize: none;\r\n    font-size: 11px;\r\n}\r\n\r\n#confChatBox {\r\n    width: 97%;\r\n    height: 100px;\r\n    resize: none;\r\n    overflow: auto;\r\n    font-size: 11px;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/client/conference.css"],"names":[],"mappings":"AAAA;;;;;CAKC;AACD;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;;;;;;CAMC;AACD;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,cAAc;IACd,eAAe;AACnB","sourcesContent":["/*\r\n* CSS for conferencing.\r\n* NOTE, the  ! importants are necessary because this css file\r\n* is loaded before the viewer css files. And the sizes in the\r\n* viewer css aren't correct with bootstrap\r\n*/\r\n#confSetupDialog {\r\n    height: 245px ! important;\r\n    overflow-y: hidden;\r\n    overflow-x: hidden;\r\n}\r\n\r\n#DSCInviteForm {\r\n    margin: 0px ! important;\r\n}\r\n\r\n#dscInviteTextArea {\r\n    width: 90%;\r\n    margin-left: 10px;\r\n    margin-top: 10px;\r\n    height: 140px;\r\n    resize: none;\r\n}\r\n\r\n#dscInvitorName {\r\n    font-weight: bold;\r\n}\r\n\r\n#dscPopup {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    overflow: hidden;\r\n    margin: 0;\r\n    background: #fff;\r\n    z-index: 100;\r\n}\r\n\r\n#dscUserListDiv {\r\n    border: 1px solid #A5A5A5;\r\n    height: 80px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n#dscUserListDiv ul {\r\n    margin-left: 5px ! important;\r\n    padding: 0;\r\n}\r\n\r\n#prtListId {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin-left: 5px ! important;\r\n    margin-right: 5px ! important;\r\n}\r\n\r\n.dscImg {\r\n    margin-left: 5px ! important;\r\n    margin-right: 5px ! important;\r\n}\r\n\r\n.dscUserListItem {\r\n    float: left;\r\n    font-size: 14px;\r\n    width: 100%;\r\n    list-style-type: none;\r\n}\r\n\r\n#dscMsgTextArea {\r\n    height: 110px;\r\n    margin-top: 8px;\r\n    resize: none;\r\n    width: 100%;\r\n}\r\n\r\n.dscHeader {\r\n    color: #666666;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n}\r\n\r\n.dscUserCheckbox {\r\n    margin-left: 5px ! important;\r\n    margin-right: 5px ! important;\r\n}\r\n\r\n/*\r\n* CSS for conferencing.\r\n*  The styles below came from ESM code:\r\n*       htdocs\\CSS\\DSC.css\r\n*  All conferencing styles are centralized here and both code\r\n*  bases use the same js functions for creating dialogs\r\n*/\r\ndiv[aria-describedby=\"confManager\"] {\r\n    min-width: 355px;\r\n}\r\n\r\n#confManager {\r\n    overflow: auto;\r\n    height: 490px;\r\n    width: 265px;\r\n}\r\n\r\n.confBtn.ui-widget {\r\n    float: right;\r\n    font-size: 10px;\r\n    margin-left: 2px;\r\n    margin-top: 4px;\r\n}\r\n\r\n.dscHeaderImg {\r\n    padding: 5px;\r\n    vertical-align: middle;\r\n}\r\n\r\n#prtListId li:nth-child(even) {\r\n    background: #EFEFEF;\r\n}\r\n\r\n#prtListId li {\r\n    font-size: 12px;\r\n    margin: 2px;\r\n}\r\n\r\n#prtListDiv {\r\n    border: #D1D1D1 solid 1px;\r\n    height: 175px;\r\n    margin: 0px;\r\n    overflow: auto;\r\n}\r\n\r\n#outgoingChatBox {\r\n    width: 97%;\r\n    height: 50px;\r\n    resize: none;\r\n    font-size: 11px;\r\n}\r\n\r\n#confChatBox {\r\n    width: 97%;\r\n    height: 100px;\r\n    resize: none;\r\n    overflow: auto;\r\n    font-size: 11px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/api.js":
/*!*****************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/api.js ***!
  \*****************************************************/
/***/ ((module) => {



/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/cssWithMappingToString.js":
/*!************************************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/cssWithMappingToString.js ***!
  \************************************************************************/
/***/ ((module) => {



function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

module.exports = function cssWithMappingToString(item) {
  var _item = _slicedToArray(item, 4),
      content = _item[1],
      cssMapping = _item[3];

  if (typeof btoa === "function") {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || "").concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join("\n");
  }

  return [content].join("\n");
};

/***/ }),

/***/ "./src/client/conference.css":
/*!***********************************!*\
  !*** ./src/client/conference.css ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! !../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_conference_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! !!../../node_modules/css-loader/dist/cjs.js!./conference.css */ "./node_modules/css-loader/dist/cjs.js!./src/client/conference.css");

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_conference_css__WEBPACK_IMPORTED_MODULE_1__.default, options);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_conference_css__WEBPACK_IMPORTED_MODULE_1__.default.locals || {});

/***/ }),

/***/ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/*!****************************************************************************!*\
  !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : 0;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!*****************************!*\
  !*** ./src/client/index.js ***!
  \*****************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "apConferencing": () => (/* binding */ apConferencing)
/* harmony export */ });
/* harmony import */ var _conference_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./conference.css */ "./src/client/conference.css");
/* harmony import */ var _confEvents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./confEvents */ "./src/client/confEvents.js");
/* harmony import */ var _Conference__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Conference */ "./src/client/Conference.js");
/* harmony import */ var _MessageQueue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MessageQueue */ "./src/client/MessageQueue.js");
/* harmony import */ var _Connection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Connection */ "./src/client/Connection.js");
/* harmony import */ var _ClientInterface__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ClientInterface */ "./src/client/ClientInterface.js");
/* harmony import */ var _ClientVil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ClientVil */ "./src/client/ClientVil.js");
/* harmony import */ var _jquery_conference__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./jquery.conference */ "./src/client/jquery.conference.js");









function initializeConferencingModule($, events, sysParams, translate, leica) {
  // build legacy module for compat with eSM
  leica.pi = leica.pi || {};
  leica.pi.util = leica.pi.util || {}; // util is an odd namespace for this module but that's where it was added...

  const conference = new _Conference__WEBPACK_IMPORTED_MODULE_2__.Conference(sysParams, $, events, translate);
  const q = new _MessageQueue__WEBPACK_IMPORTED_MODULE_3__.MessageQueue();
  const connection = (0,_Connection__WEBPACK_IMPORTED_MODULE_4__.createDscConnection)(translate, q);
  const clientInterface = new _ClientInterface__WEBPACK_IMPORTED_MODULE_5__.ClientInterface(connection);
  const clientVil = (0,_ClientVil__WEBPACK_IMPORTED_MODULE_6__.createDscClientVil)($, events, translate, conference, clientInterface); // TODO: decouple this circular dependency

  conference.setClientVil(clientVil); // initialize the jquery plugin, used in the WebViewer conferencing plugin. TODO: this really doesn't need to be a plugin

  (0,_jquery_conference__WEBPACK_IMPORTED_MODULE_7__.initJQueryPlugin)($, events, leica, conference, clientInterface, clientVil); // Export the conf instance

  leica.pi.util.conference = conference;
}

const apConferencing = {
  confEvent: _confEvents__WEBPACK_IMPORTED_MODULE_1__.confEvent,
  init: initializeConferencingModule
};
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=apConference.js.map